import { FC } from 'react';
import { CommonIconProps } from 'src/components/Icons/commonIconProps';

export const MenuStartGuideIcon: FC<CommonIconProps> = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      /* eslint-disable-next-line max-len */
      d="M6.5 23C6.22386 23 6 22.7761 6 22.5L6 2.61303C6 1.87086 6.78 1.3873 7.44473 1.71737L19.2288 7.56863C19.9631 7.93326 19.9707 8.97807 19.2418 9.35337L7.8 15.2444V22.5C7.8 22.7761 7.57614 23 7.3 23H6.5ZM7.8 12.9096L17.4 8.44812L7.8 3.98664V12.9096Z"
      fill="currentColor"
    />
  </svg>
);
